import { useKeyCloak } from '@/hooks/useKeyCloak'
import { useDispatch } from 'react-redux'

import { useActiveIncidentsFilterQuery } from '@/graphql/generated/hooks'
import {
  buildActiveFilter,
  buildActiveFilterCriteria,
} from '@/redux/incidents/conversion'
import { setRemoteActiveFilterSnapshot } from '@/redux/incidents/incidentsSlice'

export const ActiveFilterProvider = ({
  children,
}: {
  children?: React.ReactNode
}) => {
  const dispatch = useDispatch()
  const { isValidLogin } = useKeyCloak()
  useActiveIncidentsFilterQuery({
    errorPolicy: 'all',
    skip: !isValidLogin,
    onCompleted: (data) => {
      dispatch(
        setRemoteActiveFilterSnapshot({
          activeFilter: buildActiveFilter(data),
          activeFilterCriteria: buildActiveFilterCriteria(data),
        })
      )
    },
    onError: () => {
      dispatch(
        setRemoteActiveFilterSnapshot({
          activeFilter: null,
          activeFilterCriteria: null,
        })
      )
    },
  })

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>
}
